import {
  NgModule,
  Type,
  ModuleWithProviders
} from '@angular/core';
import {
  ROOT_COMPONENTS,
  FEATURE_COMPONENTS
} from './tokens';
import { ComponentFeatureModule } from './component-feature.module';
import { ComponentRootModule } from './component-root.module';

@NgModule()
export class DxComponentRegisterModule {

  public static forRoot(
    components: Array<Type<any>> = [],
  ): ModuleWithProviders<ComponentRootModule> {
    return {
      ngModule: ComponentRootModule,
      providers: [
        {
          provide: ROOT_COMPONENTS,
          useValue: components,
        }
      ]
    };
  }

  public static forFeature(
    components: Array<Type<any>>,
  ): ModuleWithProviders<ComponentFeatureModule> {
    return {
      ngModule: ComponentFeatureModule,
      providers: [
        {
          provide: FEATURE_COMPONENTS,
          multi: true,
          useValue: components,
        },
      ]
    }
  }

}
